import LoginDelayRestService from '../rest/LoginDelayRestService'
import { TFunction } from 'i18next'

class LoginDelayService {
  static get() {
    return LoginDelayRestService.get()
  }

  static async update(loginDelay: any, t: TFunction, setLoginDelay: React.Dispatch<any>) {
    try {
      const updatedLoginDelay = await LoginDelayRestService.update(loginDelay)
      setLoginDelay(updatedLoginDelay)
      return t('loginDelay.configureSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async reset(t: TFunction, setLoginDelay: React.Dispatch<any>) {
    try {
      const updatedLoginDelay = await LoginDelayRestService.reset()
      setLoginDelay(updatedLoginDelay)
      return t('loginDelay.resetSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default LoginDelayService
